import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import { Articoli } from 'src/app/models/articoli';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { Dipendente } from 'src/app/models/dipendente';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { DettaglioArticoloDipendenteService } from 'src/app/shared/services/dettaglio-articolo-dipendente.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { GridStoricoConsegneArticoloDipendenteComponent } from '../../dipendenti/grid-storico-consegne-articolo-dipendente/grid-storico-consegne-articolo-dipendente.component';
import { Parametri } from 'src/app/models/parametri';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-articoli-consegnati',
  templateUrl: './articoli-consegnati.component.html',
  styleUrls: ['./articoli-consegnati.component.scss'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxButtonComponent,
    DxPopupComponent,
    GridStoricoConsegneArticoloDipendenteComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoEditingComponent,
    DxTemplateDirective,
    DxoLookupComponent,
    DxiValidationRuleComponent,
    DxoTextsComponent,
    DxoExportComponent
  ],
})
export class ArticoliConsegnatiComponent implements OnInit, OnChanges {
  private dettArtDipService = inject(DettaglioArticoloDipendenteService);
  private categoriaArticoliService = inject(CategorieArticoliService);
  private articoliService = inject(ArticoliService);
  private tipiArticoliService = inject(TipiArticoliService);
  private movService = inject(MovimentoArticoliService);
  private dipendentiService = inject(DipendentiService);
  private parametriService = inject(ParametriService);
  @ViewChild('gridArticoliConsegnati', { static: false })
    dataGrid!: DxDataGridComponent;

  @Input() idDipendente: number = 0;
  @Input() idArticolo: number = 0;
  @Input() filterEnable: boolean = false;

  @Input() listDetArtDip: any;
  @Input() filtro: number = 0;
  @Input() bConsultazione: boolean = false;

  @Input() listDettaglio: DettaglioMovimento[] = [];

  dataSource: any;
  consegneList: any[] = [];
  bEditing: boolean = false;

  listCatArt: CategorieArticoli[] = []; // categorie Articoli
  selectedCat: number = 0;

  listArticoli: Articoli[] = []; // Lista Articoli
  listArticoliFiltrati: Articoli[] = []; // Lista Articoli Filtrati
  listTipiArticoli: TipiArticoli[] = []; //Lista TipiArticoli
  listTipiArticoliByMansione: TipiArticoli[] = []; // TipiArticoli By Mansione
  listTipiArticoliFiltrati: TipiArticoli[] = []; // Lista Tipi Articoli Filtrati
  listDipendenti: Dipendente[] = [];

  dettaglioMovimento: DettaglioMovimento = new DettaglioMovimento(); // Utilizzato per consegna nuova articolo al dipendente
  idArticoloRif: number = 0;
  idDipendenteRif: number = 0;
  popUpVisible: boolean = false;

  //Parametri
  parametro: Parametri = new Parametri();
  giorniPreAlertArticoli = 0;

  constructor() {
    this.getFilteredArticoli = this.getFilteredArticoli.bind(this);
  }

  ngOnInit() {
    // this.loadCategorieArticoli(); //Carico le categorie degli articoli
    // this.loadArticoli(); // Carico lista articoli
    // this.loadTipiArticolo(); // Carico lista tipi Articolo
    this.lodLookUp();
    this.getParametro();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const dipendenteChanged =
      changes['idDipendente'] &&
      changes['idDipendente'].currentValue !==
        changes['idDipendente'].previousValue;

    const articoloChanged =
      changes['idArticolo'] &&
      changes['idArticolo'].currentValue !==
        changes['idArticolo'].previousValue;

    const filtroChanged =
      changes['filtro'] &&
      changes['filtro'].currentValue !== changes['filtro'].previousValue;

    if (this.filtro && filtroChanged) {
      this.filterByCategory(this.filtro);
    }

    if (
      (this.idDipendente && dipendenteChanged) ||
      (this.idArticolo && articoloChanged)
    ) {
      await this.loadConsegne();
    }

    if (this.filtro && filtroChanged) {
      this.filterByCategory(this.filtro);
    }
  }

  lodLookUp() {
    // Dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listDipendenti = res;
        }
      }
    });

    // Lista Categorie
    this.categoriaArticoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listCatArt = res;
        }
      }
    });

    //Lista Articoli
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listArticoli = res.filter(x => x.attivo == true).sort((a, b) =>
            a.descrizione < b.descrizione ? -1 : 1,
          );
          this.listArticoliFiltrati = this.listArticoli;
        }
      }
    });

    //Lista Tipi Articoli
    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        if (res != null) {
          this.listTipiArticoli = res.sort((a, b) =>
            a.descrizione < b.descrizione ? -1 : 1,
          );
          this.listTipiArticoliFiltrati = this.listTipiArticoli;
        }
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articolo');
      },
    });
  }

  getFilteredArticoli(options: any) {
    const ret = {
      store: this.listArticoliFiltrati,
      filter: options.data
        ? ['idTipo', '=', options.data.idTipoArticolo]
        : null,
    };
    return ret;
  }

  /*
    setTipoValue(rowData: any, value: any): void {
      rowData.idArticolo = null;
      (<any>this).defaultSetCellValue(rowData, value);
    }
  */

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }
    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }

  getTitleButton(id: number, descrizione: string) {
    if (id > 0) {
      return (
        descrizione +
        ' (' +
        this.consegneList?.filter((x) => x.idCategoria == id).length +
        ')'
      );
    } else {
      return descrizione + ' (' + this.consegneList?.length + ')';
    }
  }

  filterByCategory(catId: number) {
    this.selectedCat = catId;
    // console.log('Categoria selezionata:', catId);

    //Filtro la grid
    this.dataGrid?.instance.clearFilter(); // Pulisco filtro grid
    this.listArticoliFiltrati = this.listArticoli;
    this.listTipiArticoliFiltrati = this.listTipiArticoli;

    if (catId && catId > 0) {
      //Filtro la grid per la categori selezionata
      this.dataGrid?.instance.filter([['idCategoria', '=', catId]]);

      //Filtro i tipi articoli per categoria
      if (this.listTipiArticoli) {
        this.listTipiArticoliFiltrati = this.listTipiArticoli?.filter(
          (x) => x.idCategoria == catId,
        );
        const taFiltrati = this.listTipiArticoli?.filter(
          (x) => x.idCategoria == catId,
        );
        //Filtro gli articioli per tipo arcoli
        this.listArticoliFiltrati = this.listArticoli.filter((a) =>
          taFiltrati.some((t) => t.id === a.idTipo),
        ); // se esiste almeno una tipologia
      }
    }
  }

  loadConsegne() {
    this.dataSource = new CustomStore({
      key: ['idArticolo', 'idDipendente'],
      load: () => {
        return firstValueFrom(
          this.movService.listConsegne(this.idDipendente, this.idArticolo),
        )
          .then((response) => {
            this.consegneList = response;
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }

  loadArticoliDip() {
    this.dataSource = new CustomStore({
      key: ['idArticolo', 'idDipendente'],
      load: () => {
        return firstValueFrom(
          this.dettArtDipService.listByDipendente(this.idDipendente),
        )
          .then((response) => {
            this.consegneList = response;

            // Applica filtro solo dopo caricamento dati
            if (this.filtro && this.filtro > 0) {
              setTimeout(() => this.filterByCategory(this.filtro), 0);
            }

            return {
              data: response,
            };
          })
          .catch((error: HttpErrorResponse) => {
            throw error.error.title;
          });
      },
      /* load: (loadOptions) => {        
         return this.articoliList;
       },
       */

      byKey: (values) => {
        return firstValueFrom(
          this.dettArtDipService.get(values.idArticolo, values.idDipendente),
        ).catch((error: HttpErrorResponse) => {
          //throw 'Deletion failed'
          console.log(error.error.title);
          throw error.error.title;
        });
      },
      insert: (values) => {
        values.idDipendente = this.idDipendente;
        return firstValueFrom(this.dettArtDipService.insert(values))
          .then(() => {
            return values;
            //this.loadArticoliDip();
          })
          .catch((error: HttpErrorResponse) => {
            //throw 'Deletion failed'
            console.log(error.error.title);
            throw error.error.title;
          });
      },
      remove: (values) => {
        return firstValueFrom(
          this.dettArtDipService.remove(values.idArticolo, values.idDipendente),
        )
          .then(() => {
            //this.loadArticoliDip();
          })
          .catch((error: HttpErrorResponse) => {
            //throw 'Deletion failed'
            console.log(error.error.title);
            throw error.error.title;
          });
      },
      update: (key, values) => {
        return firstValueFrom(
          this.dettArtDipService.update(
            key.idArticolo,
            key.idDipendente,
            values,
          ),
        )
          .then(() => {
            // this.loadArticoliDip();
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  onInitNewRow() {
    this.bEditing = true;
  }

  onEditingStart() {
    this.bEditing = false;
  }

  getParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.parametro = res;
        this.giorniPreAlertArticoli = this.parametro.valNum;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero parametro');
      },
    });
  }

  onRowPrepared(e: any) {
    if (e) {
      if (e.rowType === 'data' && e.data.dataScadenza) {
        const dataScadenza = moment(e.data.dataScadenza); //, 'YYYY-MM-DD'
        const oggi = moment().format('YYYY-MM-DD');

        if (dataScadenza.isSameOrBefore(oggi, 'day')) {
          // Scadenza oggi o già passata
          e.rowElement.style.backgroundColor = '#ffcccc';
        } else {
          const diffGiorni = e.dataScadenza?.diff(oggi, 'days'); //differenza giorni
          if (diffGiorni > 0 && diffGiorni <= this.giorniPreAlertArticoli) {
            e.rowElement.style.backgroundColor = '#fff3cd';
          }
        }
      }
    }
  }

  /* Ordinamento lookup  */
  sortByLookup(data: any) {
    const column = this as any;
    const value = column.calculateCellValue(data);
    const ret = column.lookup.calculateCellValue(value);
    return ret;
  }

  /* POPUP STORICO CONSEGNE */
  apriPopUpStorico(e: any) {
    if (this.idArticolo > 0) {
      //Da dettaglio articolo
      this.idArticoloRif = this.idArticolo;
      this.idDipendenteRif = e.idDipendente;
      this.popUpVisible = true;
    } else {
      this.idArticoloRif = e.idArticolo;
      this.idDipendenteRif = this.idDipendente;
      this.popUpVisible = true;
    }
  }

  onPopupCloseClick() {
    this.popUpVisible = false;
  }

  onExporting(e: any){
    const dip = this.listDipendenti.find(x => x.id == this.idDipendente);
    const nomeFile = 'Articoli_Consegnati_' + (dip != undefined ? (dip?.nominativo + '.xlsx') : 'xlsx');
    GridExportExcel(e, 'Articoli Consegnati', nomeFile);
  }
}
